module.exports = __webpack_public_path__ + "img/fortunefactory.6c64272a.svg";